module.exports = __webpack_public_path__ + "static/media/mesh-box-1.172daaf8.svg";